import React, { useState, useEffect } from "react"
import { Layout } from "antd"
import SmartCardList from "../SmartCard/SmartCardList"
import { fetchUserCards } from "../../../api/Cards"
import { useUser } from "../../../contexts/UserContext"
import "./SmartProductsDashboard.css"

const { Content } = Layout

const SmartProductsDashboard = () => {
    const [cards, setCards] = useState()
    const { getToken } = useUser()

    useEffect(() => {
        const token = getToken()
        if (!token) return
        const loadCards = async () => {
            try {
                const { data } = await fetchUserCards(token)
                const _cards =
                    data &&
                    data.length > 0 &&
                    data
                        .map(({ Cards }) =>
                            Cards.map((card) => ({
                                id: card.CardId,
                                cardIndex: card.CardIndex,
                                cardName: card.CardName,
                                modelName: card.ModelName,
                                status: card.Status,
                                serial: card.SerialNo,
                                hwmodel: card.Hwmodel,
                                hwver: card.Hwver,
                                swver: card.Swver
                            }))
                        )
                        .flat()

                setCards(_cards)
            } catch (err) {
                console.error("Error fetching cards", err)
            }
        }

        loadCards()
    }, [getToken])

    return (
        <Layout className="layout">
            <Content>
                <div className="site-layout-content">
                    <SmartCardList smartCards={cards} />
                </div>
            </Content>
        </Layout>
    )
}

export default SmartProductsDashboard
